function CalculateInvoiceDiscount(p, price) {
  let percentage = parseFloat(p);
  let priceAmount = parseFloat(price);

  return (percentage / 100) * priceAmount;
}

export { CalculateInvoiceDiscount };
